import { TAX_INFO_ROUTE } from "./TaxInfo.constatnts";
import { TaxInfoTable } from "./TaxInfoTable";

export const taxInfoRoutes = [
    { path: `${TAX_INFO_ROUTE}`, exact: true, element: <TaxInfoTable /> },
]